import React, { useState, useEffect, useRef } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import uuid from "react-uuid";
import ImageUpload from "components/ImageUpload";
import { Formik } from "formik";
import FormikPhone from "./FormikPhone";
import FormikDni from "./FormikDni";
import InputMask from "react-input-mask";
import { connect } from "react-redux";
import { SetUser } from "redux/actions/userActions";
import { UpdateImage } from "redux/actions/changeImageActions";
import { UpdateNameOrCareer } from "redux/actions/changeNameOrCareerActions";
import { SetOperationSuccess } from "redux/actions/operationSuccessActions";
import { get, put, putFiles, post } from "services";
import BaseSelect from "components/baseSelect";
import ParentBaseSelect from "components/BaseParentSelect";
import ProfilePictureComponent from "components/ProfilePicture";
import validateDominicanId from "validacion-cedula-dominicana";
import Spinner from "react-bootstrap/Spinner";
import Alerts from "utils/alerts";
import Constants from "utils/constants";
import { useHistory } from "react-router";
import { SetLoading } from "redux/actions/loadingActions";
import { SetHasPersonalData } from "redux/actions/hasPersonalDataReducerActions";
import { ToastContainer, toast } from "react-toastify";
import BaseSelectOptions from "components/baseSelectOptions";
import "react-toastify/dist/ReactToastify.css";
import FormikEmergencyContact from "./FormikEmergencyContact";

let yup = require("yup");
const Swal = require("sweetalert2");
const cantidadDeContactos = Constants.CANTIDAD_CONTACTOS_EMERGENCIA;

const UserForm = ({
  user,
  SetLoading,
  UpdateImage,
  UpdateNameOrCareer,
  SetOperationSuccess,
  opeationSuccess,
  changeImage,
  changeNameOrCareerReducer,
  SetHasPersonalData,
  hasPersonalDataReducer,
}) => {
  //const [reCAPTCHA, setReCAPTCHA] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [yesNoOptions, setYesNoOptions] = useState([
    { value: 1, label: "Sí" },
    { value: 0, label: "No" },
  ]);

  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [emergencyContact, setEmergencyContact] = useState([]);
  const [profilePicture, setProfilePicture] = useState(null);
  const [dniDocuments, setDniDocuments] = useState([]);
  const [loadForm, setLoadForm] = useState(false);
  const [formContent, setFormContent] = useState({});
  const [formikSchema, setFormikSchema] = useState({});
  const [dniTipoSelected, setDniTipoSelected] = useState(1);
  const [paisId, setPaisId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [provinciaId, setProvinciaId] = useState(0);
  const [saveAndContinue, setSaveAndContinue] = useState(false);
  const [personaDiscapacidades, setPersonaDiscapacidades] = useState([]);
  const [personaAparatos, setPersonaAparatos] = useState([]);
  const [discapacidadId, setDiscapacidadId] = useState(0);
  const [aparatoId, setAparatoId] = useState(0);
  const [discapacidades, setDiscapacidades] = useState([]);
  const [aparatos, setAparatos] = useState([]);
  const [basicSchema, setBasicSchema] = useState({
    identityDocument: yup
      .number()
      .typeError("El campo es numérico")
      .required("El campo es requerido"),
    identificationNumber: yup
      .string()
      .required("El campo es requerido"),
    names: yup
      .string()
      .matches(
        /^[A-Za-zá-ýÁ-Ý\s]*$/,
        "Debe ingresar solo carácteres alfabéticos"
      )
      .required("El campo es requerido"),
    lastName1: yup
      .string()
      .matches(
        /^[A-Za-zá-ýÁ-Ý\s]*$/,
        "Debe ingresar solo carácteres alfabéticos"
      )
      .required("El campo es requerido"),
    lastName2: yup
      .string("")
      .matches(
        /^[A-Za-zá-ýÁ-Ý\s]*$/,
        "Debe ingresar solo carácteres alfabéticos"
      ),
    sex: yup
      .number()
      .typeError("El campo es numérico")
      .required("El campo es requerido"),
    bloodType: yup.string().nullable(true).notRequired(),
    civilState: yup
      .number()
      .typeError("El campo es numérico")
      .required("El campo es requerido"),
    profession: yup
      .number()
      .typeError("El campo es numérico")
      .required("El campo es requerido"),
    birthPlace: yup.string().required("El campo es requerido"),
    license: yup
      .number()
      .typeError("El campo es numérico")
      .required("El campo es requerido"),
    hasVehicle: yup
      .number()
      .typeError("El campo es numérico")
      .required("El campo es requerido"),
    birthDate: yup
      .string()
      .test(
        "len",
        "Must be exactly 10 characters",
        (val) => {
          if (val === undefined) return false
          return val.toString().replaceAll("_", "").length === 10
        }
      )
      .required("El campo es requerido"),
    birthDayDate: yup.string().nullable(true).notRequired(),
    country: yup
      .number()
      .typeError("El campo es numérico")
      .required("El campo es requerido"),
    region: yup
      .number()
      .typeError("El campo es numérico")
      .required("El campo es requerido"),
    province: yup
      .number()
      .typeError("El campo es numérico")
      .required("El campo es requerido"),
    tshirtSize: yup.string(),
    city: yup
      .number()
      .typeError("El campo es numérico")
      .required("El campo es requerido"),
    direction: yup.string().required("El campo es requerido"),
    email: yup
      .string()
      .email("El campo es un correo")
      .required("El campo es requerido"),
    emailAlternativo: yup
      .string()
      .email("El campo es un correo")
      .nullable(true)
      .notRequired(),
    pantSize: yup.string(),
    emergencyContactName: yup
      .string()
      .matches(
        /^[A-Za-zá-ýÁ-Ý\s]*$/,
        "Debe ingresar solo carácteres alfabéticos"
      )
      .required("El campo es requerido"),
    emergencyContactPhone: yup.string().required("El campo es requerido"),
    emergencyContactKinship: yup
      .number()
      .typeError("El campo es numérico")
      .required("El campo es requerido"),
    
  });
  const formRef = useRef();
  const symbols = ["(", ")", "-", " "];
  const history = useHistory();
  const [sizesArr, setSizesArr] = useState([
    {
      id: "XXS",
      nombre: "XXS",
    },
    {
      id: "XS",
      nombre: "XS",
    },
    {
      id: "S",
      nombre: "S",
    },
    {
      id: "M",
      nombre: "M",
    },
    {
      id: "L",
      nombre: "L",
    },
    {
      id: "XL",
      nombre: "XL",
    },
    {
      id: "XXL",
      nombre: "XXL",
    },
    {
      id: "3XL",
      nombre: "3XL",
    },
  ]);

  const width100 = {
    width: "100%",
  };
  const notify = (text) =>
    toast.warn(text, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  useEffect(() => {
    (async function mounted() {
      try {
        setIsLoading(true);
        let compoundDate = null;
        let compoundBirthDayDate = null;
        let birthDate = new Date();
        let birthDayDate = new Date();
        let phones = [];
        let emergencyContacts = [];
        let dnis = [];
        let discapacidades = [];
        let aparatos = [];

        let initialSchema = {
          ...basicSchema,
        };

        if (
          user.persona.fechaNacimiento &&
          user.persona.fechaNacimiento != "0001-01-01T00:00:00"
        ) {
          birthDate = new Date(user.persona.fechaNacimiento);
          const day = birthDate.getDate();
          const month = birthDate.getMonth() + 1;
          const year = birthDate.getFullYear();
          compoundDate = `${day <= 9 ? "0" + day : day}/${
            month <= 9 ? "0" + month : month
          }/${year}`;
        }

        if (
          user.persona.fechaCumpleanios &&
          user.persona.fechaCumpleanios != "0001-01-01T00:00:00"
        ) {
          birthDayDate = new Date(user.persona.fechaCumpleanios);
          const day = birthDayDate.getDate();
          const month = birthDayDate.getMonth() + 1;
          const year = birthDayDate.getFullYear();
          compoundBirthDayDate = `${day <= 9 ? "0" + day : day}/${
            month <= 9 ? "0" + month : month
          }/${year}`;
        }

        if (!user.persona.personaDnis || user.persona.personaDnis.length == 0) {
          const response = await get(
            `PersonaDni/GetByPersonaId/${user.persona.id}`
          );
          user.persona.personaDnis = response.data;
        }

        if (user.persona.personaDnis.length > 0) {
          setDniTipoSelected(user.persona.personaDnis[0].dniTipoId);
        }

        let provinciaId = "";
        let regionId = "";

        if (user.persona.ciudadId) {
          const ciudad = await get(
            `Ciudad?$filter=Id eq ${user.persona.ciudadId}`
          );
          provinciaId = ciudad.data[0].provinciaId;
          const provincia = await get(`Provincia?$filter=Id eq ${provinciaId}`);
          regionId = provincia.data[0].regionId;
          setPaisId(user.persona.paisId);
          setRegionId(regionId);
          setProvinciaId(provinciaId);
        }

        let initialValues = {
          identityDocument:
            user.persona.personaDnis.length > 0
              ? user.persona.personaDnis[0].dniTipoId
              : "",
          identificationNumber:
            user.persona.personaDnis.length > 0
              ? user.persona.personaDnis[0].dni
              : "",
          names: user.persona.nombre ?? "",
          lastName1: user.persona.primerApellido ?? "",
          lastName2: user.persona.segundoApellido ?? "",
          sex: user.persona.sexoId,
          bloodType: user.persona.sangreTipoId,
          civilState: user.persona.estadoCivilId,
          profession: user.persona.profesionId,
          birthPlace: user.persona.lugarNacimiento ?? "",
          license: user.persona.licenciaConducir ?? 0,
          hasVehicle: user.persona.tieneVehiculo ?? 0,
          birthDate: compoundDate,
          birthDayDate: compoundBirthDayDate,
          country: user.persona.paisId,
          region: regionId,
          province: provinciaId,
          city: user.persona.ciudadId,
          direction: user.persona.direccion ?? "",
          email: user.persona.email ?? "",
          emailAlternativo: user.persona.emailAlternativo ?? "",
          tshirtSize: user.persona.sizeCamisa ?? "",
          pantSize: user.persona.sizePantalon ?? "",
          emergencyContactName: user.persona.nombreContacto ?? "",
          emergencyContactPhone: user.persona.telefonoContacto ?? "",
          emergencyContactKinship: user.persona.parentescoId ?? "",
        };

        if (
          !user.persona.personaContactosEmergencia ||
          user.persona.personaContactosEmergencia === 0
        ) {
          const response = await get(
            `PersonaContactosEmergencia/GetByPersonaId/${user.persona.id}`
          );
          user.persona.personaContactosEmergencia = response.data;
        }

        if (
          user.persona.personaContactosEmergencia &&
          user.persona.personaContactosEmergencia.length > 0
        ) {
          let emergencyContacstSchema = {};
          let emergencyContactsValue = {};
          user.persona.personaContactosEmergencia.forEach(
            (emergencyContact) => {
              emergencyContacstSchema = {
                ...emergencyContacstSchema,
                [`firstName_${emergencyContact.id}`]: yup
                  .string(),
                [`phoneNumber_${emergencyContact.id}`]: yup
                  .string(),
                [`email_${emergencyContact.id}`]: yup.string(),
                [`kinship_${emergencyContact.id}`]: yup
                  .string(),
              };
              emergencyContactsValue = {
                ...emergencyContactsValue,
                [`firstName_${emergencyContact.id}`]: emergencyContact.nombre,
                [`phoneNumber_${emergencyContact.id}`]:
                  emergencyContact.telefono,
                [`email_${emergencyContact.id}`]: emergencyContact.email,
                [`kinship_${emergencyContact.id}`]:
                  emergencyContact.parentescoId,
              };
              emergencyContacts.push({
                id: emergencyContact.id,
                estado: emergencyContact.estado,
                isNew: false,
              });
            }
          );
          initialSchema = {
            ...initialSchema,
            ...emergencyContacstSchema,
          };
          initialValues = {
            ...initialValues,
            ...emergencyContactsValue,
          };
        }

        if (
          !user.persona.personaTelefonos ||
          user.persona.personaTelefonos.length == 0
        ) {
          const response = await get(
            `PersonaTelefono/GetByPersonaId/${user.persona.id}`
          );
          user.persona.personaTelefonos = response.data;
        }

        if (
          user.persona.personaTelefonos &&
          user.persona.personaTelefonos.length > 0
        ) {
          let phonesSchema = {};
          let phonesValues = {};
          user.persona.personaTelefonos.forEach((phone) => {
            phonesSchema = {
              ...phonesSchema,
              [`phoneNumber_${phone.id}`]: yup
                .string()
                .required("El campo es requerido"),
              [`phoneType_${phone.id}`]: yup
                .number()
                .required("El campo es requerido"),
            };
            phonesValues = {
              ...phonesValues,
              [`phoneNumber_${phone.id}`]: phone.numero,
              [`phoneType_${phone.id}`]: phone.telefonoTipoId,
            };
            phones.push({
              id: phone.id,
              estado: phone.estado,
              isNew: false,
            });
          });
          initialSchema = {
            ...initialSchema,
            ...phonesSchema,
          };
          initialValues = {
            ...initialValues,
            ...phonesValues,
          };
        }

        if (!user.persona.personaDiscapacidades || user.persona.personaDiscapacidades.length == 0 ) {
            user.persona.personaDiscapacidades.push({
              id: uuid(),
              discapacidadId: 0,
              descripcion: 'N/A',
              estado: 1,
              isNew: true,
            });
          
        }
        if (user.persona.personaDiscapacidades && user.persona.personaDiscapacidades.length > 0) {
          user.persona.personaDiscapacidades.forEach((discapacidad) => {
            discapacidades.push({
              id: discapacidad.id,
              discapacidadId: discapacidad.discapacidadId,
              descripcion: discapacidad.descripcion,
              estado: discapacidad.estado,
              isNew: !!discapacidad.isNew ? discapacidad.isNew : false,
            });
          });
        }
        if (!!user.persona.personaDiscapacidades) {
          let discapacidadesSchema = {};
          let discapacidadesValues = {};
          user.persona.personaDiscapacidades.forEach((discapacidad) => {
            discapacidadesSchema = {
              ...discapacidadesSchema,
              [`discapacidadId_${discapacidad.id}`]: yup.number(),
              [`discapacidadDescripcion_${discapacidad.id}`]: 
                yup.string()
                .max(300, "El campo no puede tener más de 300 caracteres")
                .required("El campo es requerido"),
            };
            discapacidadesValues = {
              ...discapacidadesValues,
              [`discapacidadId_${discapacidad.id}`]: discapacidad.discapacidadId,
              [`discapacidadDescripcion_${discapacidad.id}`]: discapacidad.descripcion,
            };
            initialSchema = {
              ...initialSchema,
              ...discapacidadesSchema,
            };
            initialValues = {
              ...initialValues,
              ...discapacidadesValues,
            };
          });
        }

        if (!user.persona.personaAparatos || user.persona.personaAparatos.length == 0 ) {
          user.persona.personaAparatos.push({
            id: uuid(),
            aparatoId: 0,
            descripcion: 'N/A',
            estado: 1,
            isNew: true,
          });
        
      }
      if (user.persona.personaAparatos && user.persona.personaAparatos.length > 0) {
        user.persona.personaAparatos.forEach((aparato) => {
          aparatos.push({
            id: aparato.id,
            aparatoId: aparato.aparatoId,
            descripcion: aparato.descripcion,
            estado: aparato.estado,
            isNew: !!aparato.isNew ? aparato.isNew : false,
          });
        });
      }
      if (!!user.persona.personaAparatos) {
        let aparatosSchema = {};
        let aparatosValues = {};
        user.persona.personaAparatos.forEach((aparato) => {
          aparatosSchema = {
            ...aparatosSchema,
            [`aparatoId_${aparato.id}`]: yup.number(),
            [`aparatoDescripcion_${aparato.id}`]: 
              yup.string()
              .max(300, "El campo no puede tener más de 300 caracteres")
              .required("El campo es requerido"),
          };
          aparatosValues = {
            ...aparatosValues,
            [`aparatoId_${aparato.id}`]: aparato.aparatoId,
            [`aparatoDescripcion_${aparato.id}`]: aparato.descripcion,
          };
          initialSchema = {
            ...initialSchema,
            ...aparatosSchema,
          };
          initialValues = {
            ...initialValues,
            ...aparatosValues,
          };
        });
      }

        if (user.persona.personaDnis && user.persona.personaDnis.length > 0) {
          user.persona.personaDnis.forEach((dni) => {
            dnis.push({
              id: dni.id,
              estado: dni.estado,
              isNew: false,
            });
          });
        }

        setBasicSchema(() => {
          return initialSchema;
        });
        updateFormik(initialSchema);
        setFormContent(() => {
          return initialValues;
        });
        setEmergencyContact(() => {
          return [...emergencyContacts];
        });
        setPhoneNumbers(() => {
          return [...phones];
        });
        setPersonaDiscapacidades(() => {
          return [...discapacidades];
        });
        setPersonaAparatos(() => {
          return [...aparatos];
        });
        setDniDocuments(() => {
          return [...dnis];
        });
        setLoadForm(true);
      } catch (error) {
        Alerts.operationFail();
      } finally {
        setIsLoading(false);
      }
    })();
    return function cleanup() {
      setPhoneNumbers([]);
      setEmergencyContact([]);
      setPersonaDiscapacidades([]);
      setPersonaAparatos([]);
      setFormContent({});
      setFormikSchema({});
    };
  }, []);

  const onFileSelected = (file) => {
    setProfilePicture(() => {
      return file;
    });
  };

  const esDiscapacidadEditable = (discapacidadId) => {
    const discapacidad = discapacidades.find(x => x.id == discapacidadId);
    let resultado = discapacidad?.editable ?? false;
    return resultado;
  };

  const esAparatoEditable = (aparatoId) => {
    const aparato = aparatos.find(x => x.id == aparatoId);
    let resultado = aparato?.editable ?? false;
    return resultado;
  };

  useEffect(() => {
    if (loadForm) {
      if (
        (user.persona.personaTelefonos &&
          user.persona.personaTelefonos.length == 0) ||
        user.persona.personaTelefonos.every((x) => x.estado == 0)
      ) {
        onAddPhoneNumber();
      }
      if (!!user.persona.personaDiscapacidades && !!(user.persona.personaDiscapacidades.length > 0)) {
        setDiscapacidadId(user.persona.personaDiscapacidades[0].discapacidadId);
      }
      if (!!user.persona.personaAparatos && !!(user.persona.personaAparatos.length > 0)) {
        setAparatoId(user.persona.personaAparatos[0].aparatoId);
      }
      
    }
  }, [loadForm]);
  useEffect(() => {
    if (loadForm) {
      if (
        (user.persona.personaContactosEmergencia &&
          user.persona.personaContactosEmergencia.length == 0) ||
        user.persona.personaContactosEmergencia.every((x) => x.estado == 0)
      ) {
        onAddEmergencyContact();
      }
    }
  }, [loadForm]);

  const updateFormik = (schema) =>
    setFormikSchema(() => {
      return yup.object(schema);
    });

  const onAddEmergencyContact = () => {
    if (emergencyContact.length + 1 > cantidadDeContactos)
      return;
    const guid = uuid();
    const oldValues = formRef.current.values;

    const newSchema = {
      ...basicSchema,
      [`firstName_${guid}`]: yup.string(),
      [`phoneNumber_${guid}`]: yup.string(),
      [`email_${guid}`]: yup.string(),
      [`kinship_${guid}`]: yup.string(),
    };

    setBasicSchema(() => {
      return newSchema;
    });

    setFormContent(() => {
      return {
        ...oldValues,
        [`firstName_${guid}`]: "",
        [`phoneNumber_${guid}`]: "",
        [`email_${guid}`]: "",
        [`kinship_${guid}`]: "",
      };
    });

    setEmergencyContact(() => {
      return [
        ...emergencyContact,
        {
          id: guid,
          estado: 1,
          isNew: true,
        },
      ];
    });

    updateFormik(newSchema);
  };

  // const onRemoveEmergencyContact = () => {

  // }

  const onAddPhoneNumber = () => {
    const guid = uuid();

    const oldValues = formRef.current.values;

    const newSchema = {
      ...basicSchema,
      [`phoneNumber_${guid}`]: yup.string().required("El campo es requerido"),
      [`phoneType_${guid}`]: yup
        .number()
        .typeError("El campo es numérico")
        .required("El campo es requerido"),
    };

    setBasicSchema(() => {
      return newSchema;
    });

    setFormContent(() => {
      return {
        ...oldValues,
        [`phoneNumber_${guid}`]: "",
        [`phoneType_${guid}`]: "",
      };
    });

    setPhoneNumbers(() => {
      return [
        ...phoneNumbers,
        {
          id: guid,
          estado: 1,
          isNew: true,
        },
      ];
    });

    updateFormik(newSchema);
  };

  const onAddDniNumber = () => {
    const guid = uuid();
    const oldValues = formRef.current.values;

    const newSchema = {
      ...basicSchema,
      [`dniTipoId_${guid}`]: yup
        .number()
        .typeError("El campo es numérico")
        .required("El campo es requerido"),
      [`dni_${guid}`]: yup.string().required("El campo es requerido"),
    };

    setBasicSchema(() => {
      return newSchema;
    });

    setFormContent(() => {
      return {
        ...oldValues,
        [`dniTipoId_${guid}`]: "",
        [`dni_${guid}`]: "",
      };
    });

    setDniDocuments(() => {
      return [
        ...dniDocuments,
        {
          id: guid,
          estado: 1,
          isNew: true,
        },
      ];
    });

    updateFormik(newSchema);
  };

  const onRemoveEmergencyContact = (identifier) => {
    let newSchema = basicSchema;
    const removedEmergencyContact = emergencyContact.find(
      (x) => x.id === identifier
    );
    const oldValues = formRef.current.values;

    const schemaKeys = [
      `firstName_${identifier}`,
      `phoneNumber_${identifier}`,
      `email_${identifier}`,
      `kinship_${identifier}`,
    ];

    schemaKeys.forEach((key) => {
      delete newSchema[key];
      delete oldValues[key];
    });

    setBasicSchema(() => {
      return newSchema;
    });

    setFormContent(() => {
      return oldValues;
    });

    updateFormik(newSchema);

    if (removedEmergencyContact.isNew) {
      setEmergencyContact(() => {
        return [...emergencyContact.filter((x) => x.id !== identifier)];
      });
    } else {
      removedEmergencyContact.estado = 0;
      setEmergencyContact(() => {
        return [...emergencyContact];
      });
    }
  };
  const onRemovePhoneNumber = (identifier) => {
    let newSchema = basicSchema;
    const removedPhone = phoneNumbers.find((x) => x.id === identifier);
    const oldValues = formRef.current.values;

    const schemaKeys = [
      `names_${identifier}`,
      `phoneNumber_${identifier}`,
      `phoneType_${identifier}`,
    ];

    schemaKeys.forEach((key) => {
      delete newSchema[key];
      delete oldValues[key];
    });

    setBasicSchema(() => {
      return newSchema;
    });

    setFormContent(() => {
      return oldValues;
    });

    updateFormik(newSchema);

    if (removedPhone.isNew) {
      setPhoneNumbers(() => {
        return [...phoneNumbers.filter((x) => x.id !== identifier)];
      });
    } else {
      //const index = phoneNumbers.indexOf(removedPhone);
      //let updatedPhoneNumbers = phoneNumbers;
      removedPhone.estado = 0;
      //updatedPhoneNumbers[index] = removedPhone;
      setPhoneNumbers(() => {
        return [...phoneNumbers];
      });
    }
  };

  const onRemovePersonaDiscapacidad = (identifier) => {
    let newSchema = basicSchema;
    const oldValues = formRef.current.values;

    const schemaKeys = [
      `discapacidadId_${identifier}`,
      `discapacidadDescripcion_${identifier}`,
    ];

    schemaKeys.forEach((key) => {
      delete newSchema[key];
      delete oldValues[key];
    });

    setBasicSchema(() => {
      return newSchema;
    });

    setFormContent(() => {
      return oldValues;
    });

    updateFormik(newSchema);
  };

  const updateValueFromSchema = (key,value) => {
    const oldValues = formRef.current.values;

    delete oldValues[key]

    setFormContent(() => {
      return {
        ...oldValues,
        [key]: value,
      };
    });

  };

  const onRemovePersonaAparato = (identifier) => {
    let newSchema = basicSchema;
    const oldValues = formRef.current.values;

    const schemaKeys = [
      `aparatoId_${identifier}`,
      `aparatoDescripcion_${identifier}`,
    ];

    schemaKeys.forEach((key) => {
      delete newSchema[key];
      delete oldValues[key];
    });

    setBasicSchema(() => {
      return newSchema;
    });

    setFormContent(() => {
      return oldValues;
    });

    updateFormik(newSchema);
  };

  const onRemoveDniNumber = (identifier) => {
    let newSchema = basicSchema;
    const removedDni = dniDocuments.find((x) => x.id === identifier);
    const oldValues = formRef.current.values;
    const schemaKeys = [`dniTipoId_${identifier}`, `dni_${identifier}`];
    schemaKeys.forEach((key) => {
      delete newSchema[key];
      delete oldValues[key];
    });
    setBasicSchema(() => {
      return newSchema;
    });
    setFormContent(() => {
      return oldValues;
    });
    updateFormik(newSchema);
    if (removedDni.isNew) {
      setDniDocuments(() => {
        return [...dniDocuments.filter((x) => x.id !== identifier)];
      });
    } else {
      removedDni.estado = 0;
      setDniDocuments(() => {
        return [...dniDocuments];
      });
    }
  };

  const onSaveAndContinue = () => {
    formRef.current.validateForm().then((data) => {
      if (Object.keys(data).length === 0 && data.constructor === Object) {
        setSaveAndContinue(true);
        formRef.current.handleSubmit();
      }
    });
  };

  const onSave = () => {
    formRef.current.validateForm().then((data) => {
      if (Object.keys(data).length === 0 && data.constructor === Object) {
        setSaveAndContinue(false);
        formRef.current.handleSubmit();
      }
    });
  };

  const onExit = () => {
    history.push({
      pathname: "/",
      state: {
        updateUserData: true,
      },
    });
  };

  const onFormSubmitted = async (form, payload) => {
    if (user.esEmpleado) {
      if (
        Number(form.birthDayDate.substring(0, 2)) > 31 ||
        Number(form.birthDayDate.substring(3, 5)) > 12 ||
        Number(form.birthDayDate.substring(6, 10)) >= new Date().getFullYear()
      ) {
        if (Number(form.birthDayDate.substring(0, 2)) > 31)
          notify("El día ingresado en la fecha de cumpleaños no es válido");
        if (Number(form.birthDayDate.substring(3, 5)) > 12)
          notify("El mes ingresado en la fecha de cumpleaños no es válido");
        if (
          Number(form.birthDayDate.substring(6, 10)) >= new Date().getFullYear()
        )
          notify("El año ingresado en la fecha de cumpleaños no es válido");
        return;
      }
    }

    if (
      Number(form.birthDate.substring(0, 2)) > 31 ||
      Number(form.birthDate.substring(3, 5)) > 12 ||
      Number(form.birthDate.substring(6, 10)) >= new Date().getFullYear()
    ) {
      if (Number(form.birthDate.substring(0, 2)) > 31)
        notify("El día ingresado no es válido");
      if (Number(form.birthDate.substring(3, 5)) > 12)
        notify("El mes ingresado no es válido");
      if (Number(form.birthDate.substring(6, 10)) >= new Date().getFullYear())
        notify("El año ingresado no es válido");
      return;
    }

    let foto;

    const propertiesToDelete = [
      "profesionUI",
      "sexoUI",
      "nacionalidadUI",
      "tipoSangreUI",
      "paisUI",
      "ciudadUI",
      "estadoCivilUI",
    ];
    let personaTelefonos = [];
    let personaDnis = [];
    let contactosEmergencia = [];
    let discapacidadesPersona = [];
    let aparatosPersona = [];

    personaDiscapacidades.forEach((discapacidad) => {
      let discapacidadId = Number(form[`discapacidadId_${discapacidad.id}`]);
      let discapacidadDescripcion = form[`discapacidadDescripcion_${discapacidad.id}`];

      const personaDiscapacidad = {};

      if (discapacidadId > 0) {
        if (!esDiscapacidadEditable(discapacidadId)){
          let descripcion = discapacidades ? discapacidades.find(x => x.id == discapacidadId).descripcion : '';
          discapacidadDescripcion = descripcion;
        }
  
        personaDiscapacidad.id = discapacidad.isNew ? null : discapacidad.id;
        personaDiscapacidad.personaId = user.persona.id;
        personaDiscapacidad.discapacidadId = discapacidadId;
        personaDiscapacidad.descripcion = discapacidadDescripcion;
        personaDiscapacidad.estado = discapacidad.estado;
        

      }
      if (discapacidadId === 0 && discapacidad.isNew == false) {
        
        personaDiscapacidad.id = discapacidad.id;
        personaDiscapacidad.personaId = user.persona.id;
        personaDiscapacidad.discapacidadId = discapacidad.discapacidadId;
        personaDiscapacidad.descripcion = discapacidad.descripcion;
        personaDiscapacidad.estado = 0;

        let index = user.persona.personaDiscapacidades.findIndex(x => x.id == discapacidad.id);
        user.persona.personaDiscapacidades.splice(index, 1);
        onRemovePersonaDiscapacidad(discapacidad.id);
      }
      if(Object.entries(personaDiscapacidad).length > 0){
        discapacidadesPersona.push(personaDiscapacidad);
      }

    });

    personaAparatos.forEach((aparato) => {
      let aparatoId = Number(form[`aparatoId_${aparato.id}`]);
      let aparatoDescripcion = form[`aparatoDescripcion_${aparato.id}`];

      const personaAparato = {};

      if (aparatoId > 0) {
        if (!esAparatoEditable(aparatoId)){
          let descripcion = aparatos ? aparatos.find(x => x.id == aparatoId).descripcion : '';
          aparatoDescripcion = descripcion;
        }
  
        personaAparato.id = aparato.isNew ? null : aparato.id;
        personaAparato.personaId = user.persona.id;
        personaAparato.aparatoId = aparatoId;
        personaAparato.descripcion = aparatoDescripcion;
        personaAparato.estado = aparato.estado;
        

      }
      if (aparatoId === 0 && aparato.isNew == false) {
        
        personaAparato.id = aparato.id;
        personaAparato.personaId = user.persona.id;
        personaAparato.aparatoId = aparato.aparatoId;
        personaAparato.descripcion = aparato.descripcion;
        personaAparato.estado = 0;

        let index = user.persona.personaAparatos.findIndex(x => x.id == aparato.id);
        user.persona.personaAparatos.splice(index, 1);
        onRemovePersonaAparato(aparato.id);
      }
      if(Object.entries(personaAparato).length > 0){
        aparatosPersona.push(personaAparato);
      }

    });

    emergencyContact.forEach((contact) => {
      let clearContactName =
        contact.estado == 0
          ? user.persona.personaContactosEmergencia.find(
              (x) => x.id == contact.id
            )?.nombre
          : form["firstName_" + contact.id];

      let clearContactNumber =
        contact.estado == 0
          ? user.persona.personaContactosEmergencia.find(
              (x) => x.id == contact.id
            )?.telefono
          : form["phoneNumber_" + contact.id];

      let clearContactEmail =
        contact.estado == 0
          ? user.persona.personaContactosEmergencia.find(
              (x) => x.id == contact.id
            )?.email
          : form["email_" + contact.id];

      let contactKinship =
        contact.estado == 0
          ? user.persona.personaContactosEmergencia.find(
              (x) => x.id == contact.id
            )?.parentescoId
          : Number(form["kinship_" + contact.id]);

      if (clearContactName == '' ||  clearContactNumber == '')
        return;

      symbols.forEach((symbol) => {
        clearContactNumber = clearContactNumber.replace(symbol, "");
      });

      const personaContactoEmergencia = {
        id: contact.isNew ? null : contact.id,
        personaId: user.persona.id,
        nombre: clearContactName,
        telefono: clearContactNumber,
        email: clearContactEmail,
        parentescoId: contactKinship,
        estado: contact.estado,
      };
      contactosEmergencia.push(personaContactoEmergencia);
    });

    for (var phoneNumber of phoneNumbers) {
      if (form[`phoneNumber_${phoneNumber.id}`] === undefined)
        continue;

      let cleanNumber = phoneNumber.isNew
        ? form["phoneNumber_" + phoneNumber.id]
        : user.persona.personaTelefonos.find(x => x.id == phoneNumber.id)?.numero;
      
      let phoneType = phoneNumber.isNew
        ? Number(form["phoneType_" + phoneNumber.id])
        : user.persona.personaTelefonos.find((x) => x.id == phoneNumber.id)?.telefonoTipoId;

      symbols.forEach((symbol) => {
        cleanNumber = cleanNumber.replace(symbol, "");
      });

      const personaTelefono = {
        id: phoneNumber.isNew ? null : phoneNumber.id,
        personaId: user.persona.id,
        numero: cleanNumber,
        telefonoTipoId: phoneType,
        estado: phoneNumber.estado,
      };
      personaTelefonos.push(personaTelefono);
    }

    const dniTipoId = Number(form["identityDocument"]);
    const dniName =
      dniTipoId == 1
        ? String(form["identificationNumber"]).replaceAll("-", "")
        : String(form["identificationNumber"]);

    if (dniDocuments.length > 0) {
      dniDocuments.forEach((dni) => {
        const personaDni = {
          id: dni.id,
          personaId: user.persona.id,
          estado: 1,
          dniTipoId,
          dni: dniName,
          DniPrincipal: 1,
        };
        personaDnis.push(personaDni);
      });
    } else {
      const personaDni = {
        id: null,
        personaId: user.persona.id,
        estado: 1,
        dniTipoId,
        dni: dniName,
        DniPrincipal: 1,
      };
      personaDnis.push(personaDni);
    }

    if (user && user.persona && user.persona.foto) {
      foto = user.persona.foto;
    }

    if (profilePicture) {
      let imageFormData = new FormData();
      imageFormData.append("file", profilePicture);
      const response = await putFiles(
        "PersonaDocumento/SaveProfileImage",
        imageFormData,
        ""
      );
      foto = response.data;
    }

    symbols.forEach((symbol) => {
      form.emergencyContactPhone = form.emergencyContactPhone.replace(
        symbol,
        ""
      );
    });

    const sangreType = Number(form.bloodType);

    const mm_dd_yyyy_format = `${form.birthDate.substring(
      3,
      5
    )}/${form.birthDate.substring(0, 2)}/${form.birthDate.substring(6, 10)}`;
    const birthDateFormat = new Date(mm_dd_yyyy_format);
    let hbdDateFormat = birthDateFormat;

    if (user.esEmpleado && form.birthDayDate) {
      const mm_dd_yyyy_hbd_format = `${form.birthDayDate.substring(
        3,
        5
      )}/${form.birthDayDate.substring(0, 2)}/${form.birthDayDate.substring(
        6,
        10
      )}`;
      hbdDateFormat = new Date(mm_dd_yyyy_hbd_format);
    }

    const dto = {
      id: Number(user.persona.id),
      nombre: form.names,
      primerApellido: form.lastName1,
      segundoApellido: form.lastName2,
      apellido: `${form.lastName1} ${form.lastName2}`,
      email: form.email,
      lugarNacimiento: form.birthPlace,
      direccion: form.direction,
      fechaNacimiento: new Date(birthDateFormat),
      fechaCumpleanios: new Date(hbdDateFormat),
      nombreContacto: form.emergencyContactName,
      telefonoContacto: form.emergencyContactPhone,
      sizeCamisa: form.tshirtSize,
      sizePantalon: form.pantSize,
      paisId: Number(form.country),
      ciudadId: Number(form.city),
      profesionId: Number(form.profession),
      estadoCivilId: Number(form.civilState),
      sangreTipoId: sangreType !== 0 ? sangreType : null,
      sexoId: Number(form.sex),
      parentescoId: Number(form.emergencyContactKinship),
      foto,
      emailAlternativo: form.emailAlternativo,
      personaAparatos: aparatosPersona,
      personaTelefonos,
      personaContactosEmergencia: contactosEmergencia,
      personaDiscapacidades: discapacidadesPersona,
      estado: 1,
      licenciaConducir: Number(form.license),
      tieneVehiculo: Number(form.hasVehicle),
    };
    setIsLoading(true);

    const response = await put("Persona", user.persona.id, dto /*, reCAPTCHA*/);

    propertiesToDelete.forEach((property) => {
      delete response.data[property];
    });

    if (sangreType == 0) {
      response.data["tipoSangreUI"] = null;
    }

    user.persona = {
      ...user.persona,
      ...response.data,
    };

    if(user.persona.personaDiscapacidades.filter(x => x.estado == 1).length === 0) {
      const response = await get(`personaDiscapacidad/getByPersonaId/${user.persona.id}`);
      user.persona.personaDiscapacidades = response.data;
    }

    if(user.persona.personaAparatos.filter(x => x.estado == 1).length === 0) {
      const response = await get(`personaAparato/getByPersonaId/${user.persona.id}`);
      user.persona.personaAparatos = response.data;
    }

    SetUser(user);
    localStorage.setItem("currentUser-ARS", JSON.stringify(user));
    setIsLoading(false);
    UpdateImage(changeImage + 1);
    UpdateNameOrCareer(changeNameOrCareerReducer + 1);

    SetOperationSuccess(opeationSuccess + 1);
    SetHasPersonalData(true);
    //

    let nextUrl = "/education";

    if (user.esEmpleado) {
      nextUrl = "/familyStructure";
    }

    const route = saveAndContinue ? nextUrl : "/";
    history.push({
      pathname: route,
      state: {
        updateUserData: true,
      },
    });
  };

  const validateCedula = async () => {
    const oldValues = formRef.current.values;
    let cedulaLimpia = String(oldValues.identificationNumber).replaceAll(
      "-",
      ""
    );
    const dto = {
      id: user.persona.email,
      cedula: cedulaLimpia,
    };
    const response = await post(`Usuario/IsValidCedula`, dto);
    const EsCedulaExistente = response.data;
    if (EsCedulaExistente) {
      Swal.fire({
        icon: "warning",
        title: "¡Atención!",
        text: "¡Ya existe un usuario con esa cédula, favor validar!",
      });
      return false;
    }
    return true;
  };

  return (
    <>
      <ToastContainer />
      {isLoading && (
        <div className={"display-flex flex-direction-row flex-center"}>
          <Spinner
            animation="grow"
            variant="primary"
            className={"is-absolute center-spinner-vertically"}
            size="lg"
          />
        </div>
      )}
      <Card>
        <Card.Body className={"p-40"}>
          {loadForm && (
            <div>
              <Formik
                innerRef={formRef}
                validationSchema={formikSchema}
                onSubmit={onFormSubmitted}
                initialValues={formContent}
                enableReinitialize={true}
                validateOnChange={false}
                validateOnBlur={false}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  isValid,
                  errors,
                  setFieldValue,
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Form.Row>
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="campos_obligatorios"
                        className="mb-25"
                        style={{ fontSize: 18 }}
                      >
                        <div>
                          <b> Campos obligatorios * </b>
                        </div>
                      </Form.Group>

                      <BaseSelect
                        md={3}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        values={values}
                        label={"Documento Identidad"}
                        name={"identityDocument"}
                        url={"DniTipo"}
                        disabled={true}
                        onSelected={(data) => setDniTipoSelected(data.id)}
                      />

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationFormik02"
                      >
                        <Form.Label>Número</Form.Label>
                        {dniTipoSelected == 1 ? (
                          <Form.Control
                            type="text"
                            mask="999-9999999-9"
                            as={InputMask}
                            name="identificationNumber"
                            value={values.identificationNumber}
                            onChange={handleChange}
                            //isValid={touched.identificationNumber && !errors.identificationNumber}
                            isInvalid={!!errors.identificationNumber}
                            disabled={true}
                          />
                        ) : (
                          <Form.Control
                            type="text"
                            name="identificationNumber"
                            value={values.identificationNumber}
                            onChange={handleChange}
                            //isValid={touched.identificationNumber && !errors.identificationNumber}
                            isInvalid={!!errors.identificationNumber}
                            disabled={true}
                          />
                        )}
                        <Form.Control.Feedback type="invalid">
                          {errors.identificationNumber}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationFormik03"
                      >
                        <Form.Label>Nombres * </Form.Label>
                        <Form.Control
                          type="text"
                          name="names"
                          placeholder="Pedro José"
                          value={values.names}
                          onChange={handleChange}
                          disabled={user.esEmpleado}
                          //isValid={touched.names && !errors.names}
                          isInvalid={!!errors.names}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.names}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationFormik04"
                      >
                        <Form.Label>Primer apellido *</Form.Label>
                        <Form.Control
                          type="text"
                          name="lastName1"
                          placeholder="Romero Fuentes"
                          value={values.lastName1}
                          onChange={handleChange}
                          disabled={user.esEmpleado}
                          //isValid={touched.lastName1 && !errors.lastName1}
                          isInvalid={!!errors.lastName1}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.lastName1}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationFormik04"
                      >
                        <Form.Label> Segundo apellido </Form.Label>
                        <Form.Control
                          type="text"
                          name="lastName2"
                          placeholder="Romero Fuentes"
                          value={values.lastName2}
                          onChange={handleChange}
                          disabled={user.esEmpleado}
                          //isValid={touched.lastName2 && !errors.lastName2}
                          isInvalid={!!errors.lastName2}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.lastName2}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <BaseSelect
                        md={3}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        values={values}
                        label={"Sexo *"}
                        name={"sex"}
                        url={"Sexo"}
                        disabled={user.esEmpleado}
                        onSelected={(data) =>
                          (user.persona.sexoUI = data.nombre)
                        }
                      />

                      <BaseSelect
                        md={3}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        values={values}
                        label={"Tipo de sangre"}
                        name={"bloodType"}
                        url={"SangreTipo"}
                        disabled={user.esEmpleado}
                        onSelected={(data) =>
                          (user.persona.tipoSangreUI = data.nombre)
                        }
                      />

                      <BaseSelect
                        md={3}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        values={values}
                        label={"Estado civil *"}
                        name={"civilState"}
                        url={"EstadoCivil"}
                        onSelected={(data) =>
                          (user.persona.estadoCivilUI = data.nombre)
                        }
                      />

                      <BaseSelect
                        md={3}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        values={values}
                        label={"Profesión *"}
                        name={"profession"}
                        url={"Profesion"}
                        onSelected={(data) =>
                          (user.persona.profesionUI = data.nombre)
                        }
                      />

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationFormik0231"
                      >
                        <Form.Label>Lugar de nacimiento *</Form.Label>
                        <Form.Control
                          type="text"
                          name="birthPlace"
                          value={values.birthPlace}
                          onChange={handleChange}
                          //isValid={touched.birthPlace && !errors.birthPlace}
                          isInvalid={!!errors.birthPlace}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.birthPlace}
                        </Form.Control.Feedback>
                      </Form.Group>

                      {/* <BaseSelect
                                                    md={3}
                                                    errors={errors}
                                                    touched={touched}
                                                    handleChange={handleChange}
                                                    values={values}
                                                    label={'Nacionalidad'}
                                                    name={'nacionality'}
                                                    url={'Pais'}
                                                    displayName={'nacionalidad'}
                                                /> */}

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationFormik11"
                      >
                        <Form.Label> Fecha de nacimiento *</Form.Label>

                        <Form.Control
                          type="text"
                          mask="99/99/9999"
                          placeholder={"dd/mm/yyyy"}
                          as={InputMask}
                          name="birthDate"
                          value={values.birthDate}
                          onChange={handleChange}
                          disabled={user.esEmpleado}
                          //isValid={touched.birthDate && !errors.birthDate}
                          isInvalid={!!errors.birthDate}
                        />
                      </Form.Group>

                      {user.esEmpleado && (
                        <Form.Group
                          as={Col}
                          md="3"
                          controlId="validationFormik11"
                        >
                          <Form.Label> Fecha de cumpleaños </Form.Label>
                          <Form.Control
                            type="text"
                            mask="99/99/9999"
                            placeholder={"dd/mm/yyyy"}
                            as={InputMask}
                            name="birthDayDate"
                            value={values.birthDayDate}
                            onChange={handleChange}
                            disabled={user.esEmpleado}
                            isInvalid={!!errors.birthDayDate}
                          />
                        </Form.Group>
                      )}

                      <ParentBaseSelect
                        md={3}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        values={values}
                        label={"País *"}
                        name={"country"}
                        url={"Pais"}
                        onParentChange={setPaisId}
                        hasDependency={false}
                        onSelected={(data) => {
                          user.persona.nacionalidadUI = data.nacionalidad;
                          user.persona.paisUI = data.nombre;
                        }}
                      />

                      <ParentBaseSelect
                        md={3}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        values={values}
                        label={"Región *"}
                        name={"region"}
                        url={"Region"}
                        parentId={paisId}
                        onParentChange={setRegionId}
                        parentName={"el país"}
                        filterBy={"PaisId"}
                      />

                      <ParentBaseSelect
                        md={3}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        values={values}
                        label={"Provincia *"}
                        name={"province"}
                        url={"Provincia"}
                        parentId={regionId}
                        onParentChange={setProvinciaId}
                        parentName={"la región"}
                        filterBy={"RegionId"}
                      />

                      <ParentBaseSelect
                        md={3}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        values={values}
                        label={"Ciudad *"}
                        name={"city"}
                        url={"Ciudad"}
                        parentId={provinciaId}
                        parentName={"la provincia"}
                        filterBy={"ProvinciaId"}
                        onSelected={(data) =>
                          (user.persona.ciudadUI = data.nombre)
                        }
                      />

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationFormik16"
                      >
                        <Form.Label>Dirección *</Form.Label>
                        <Form.Control
                          type="text"
                          name="direction"
                          placeholder="Calle No. 10 Santo Domingo"
                          value={values.direction}
                          onChange={handleChange}
                          //isValid={touched.direction && !errors.direction}
                          isInvalid={!!errors.direction}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.direction}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationFormik03"
                      >
                        <Form.Label>Correo electrónico</Form.Label>
                        <Form.Control
                          type="text"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          //isValid={touched.email && !errors.email}
                          isInvalid={!!errors.email}
                          disabled={true}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.email}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationFormik03"
                      >
                        <Form.Label>Correo electrónico alternativo</Form.Label>
                        <Form.Control
                          type="text"
                          name="emailAlternativo"
                          value={values.emailAlternativo}
                          onChange={handleChange}
                          //isValid={touched.emailAlternativo && !errors.emailAlternativo}
                          isInvalid={!!errors.emailAlternativo}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.emailAlternativo}
                        </Form.Control.Feedback>
                      </Form.Group>

                      {user && user.esEmpleado && (
                        <>
                          <BaseSelectOptions
                            md={3}
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            values={values}
                            label={"Size de camisa"}
                            name={`tshirtSize`}
                            options={sizesArr}
                          />

                          <BaseSelectOptions
                            md={3}
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            values={values}
                            label={"Size de pantalon"}
                            name={`pantSize`}
                            options={sizesArr}
                          />

                          {/* <Form.Group as={Col} md="3" controlId="validationFormik16">
                                                            <Form.Label> Size de camisa </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="tshirtSize"
                                                                value={values.tshirtSize}
                                                                onChange={handleChange}
                                                                //isValid={touched.tshirtSize && !errors.tshirtSize}
                                                                isInvalid={!!errors.tshirtSize}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.tshirtSize}
                                                            </Form.Control.Feedback>
                                                        </Form.Group> */}

                          {/* <Form.Group as={Col} md="3" controlId="validationFormik16">
                                                            <Form.Label> Size de pantalon </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="pantSize"
                                                                value={values.pantSize}
                                                                onChange={handleChange}
                                                                //isValid={touched.pantSize && !errors.pantSize}
                                                                isInvalid={!!errors.pantSize}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.pantSize}
                                                            </Form.Control.Feedback>
                                                        </Form.Group> */}
                        </>
                      )}

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId={"validationlicense_"}
                      >
                        <Form.Label> Posee licencia </Form.Label>
                        <Form.Control
                          name={`license`}
                          value={values[`license`]}
                          onChange={handleChange}
                          //isValid={touched[`license`] && !errors[`license`]}
                          isInvalid={!!errors[`license`]}
                          as="select"
                          custom
                        >
                          {yesNoOptions.map((option) => {
                            return (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            );
                          })}
                        </Form.Control>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId={"validationhasVehicle_"}
                      >
                        <Form.Label> Posee vehículo </Form.Label>
                        <Form.Control
                          name={`hasVehicle`}
                          value={values[`hasVehicle`]}
                          onChange={handleChange}
                          //isValid={touched[`hasVehicle`] && !errors[`hasVehicle`]}
                          isInvalid={!!errors[`hasVehicle`]}
                          as="select"
                          custom
                        >
                          {yesNoOptions.map((option) => {
                            return (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            );
                          })}
                        </Form.Control>
                      </Form.Group>
                    </Form.Row>

                    <Form.Row>
                      {(phoneNumbers.filter(x => x.estado == 1 && `phoneNumber_${x.id}` in values)).length == 0 ? (
                        phoneNumbers
                        .filter(
                          (x) =>
                            x.estado == 1)
                        .map((element, i) => {
                          return (
                            <FormikPhone
                              InputMask={InputMask}
                              key={element.id}
                              handleChange={handleChange}
                              errors={errors}
                              touched={touched}
                              values={values}
                              element={element}
                              removePhoneNumber={onRemovePhoneNumber}
                              index={i}
                            />
                          );
                        })
                      ) : (
                        phoneNumbers
                        .filter(
                          (x) =>
                            x.estado == 1 && `phoneNumber_${x.id}` in values
                        )
                        .map((element, i) => {
                          return (
                            <FormikPhone
                              InputMask={InputMask}
                              key={element.id}
                              handleChange={handleChange}
                              errors={errors}
                              touched={touched}
                              values={values}
                              element={element}
                              removePhoneNumber={onRemovePhoneNumber}
                              index={i}
                            />
                          );
                        })
                      )
                    }

                      <Form.Group as={Col} md="12">
                        <Button onClick={onAddPhoneNumber}>
                          {" "}
                          Agregar número de teléfono{" "}
                        </Button>
                      </Form.Group>
                    </Form.Row>
                    
                    <Form.Row>
                      <Form.Group as={Col} md="6">
                        <span>¿Usted tiene alguna condicion de discapacidad?</span>
                        {
                          personaDiscapacidades.filter(x => x.estado == 1).map((e) => {
                            return (
                              <Form.Row>
                                <BaseSelect
                                  md={4}
                                  errors={errors}
                                  touched={touched}
                                  handleChange={handleChange}
                                  values={values}
                                  label={"Discapacidad"}
                                  name={`discapacidadId_${e.id}`}
                                  url={"discapacidad"}
                                  displayName="descripcion"
                                  onSelected={(data) => {
                                    setDiscapacidadId(data.id);
                                    if(!esDiscapacidadEditable(data.id)){
                                      updateValueFromSchema(`discapacidadDescripcion_${e.id}`, data.descripcion);
                                    }
                                  }}
                                  getAllData={setDiscapacidades}
                                  customOptionValue={0}
                                  customDisplayName="N/A"
                                />
                                <Form.Group as={Col} md={8} style={{ display: esDiscapacidadEditable(discapacidadId) ? 'block' : 'none' }}>
                                  <Form.Label> Descripcion *</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name={`discapacidadDescripcion_${e.id}`}
                                    placeholder="Escribe su discapacidad"
                                    value={values[`discapacidadDescripcion_${e.id}`]}
                                    onChange={handleChange}
                                    isInvalid={!!errors[`discapacidadDescripcion_${e.id}`]}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors[`discapacidadDescripcion_${e.id}`]}
                                  </Form.Control.Feedback>
                                </Form.Group>
                                
                            </Form.Row>
                            )
                          })
                        }
                      </Form.Group>
                      <Form.Group as={Col} md="6">
                        <span>¿Su condicion requiere el uso de algun dispositivo/equipo de soporte?</span>
                        {
                          personaAparatos.filter(x => x.estado == 1).map((e) => {
                            return (
                              <Form.Row>
                                <BaseSelect
                                  md={4}
                                  errors={errors}
                                  touched={touched}
                                  handleChange={handleChange}
                                  values={values}
                                  label={"Aparato"}
                                  name={`aparatoId_${e.id}`}
                                  url={"aparato"}
                                  displayName="descripcion"
                                  onSelected={(data) => {
                                    setAparatoId(data.id);
                                    if(!esAparatoEditable(data.id)){
                                      updateValueFromSchema(`aparatoDescripcion_${e.id}`, data.descripcion);
                                    }
                                  }}
                                  getAllData={setAparatos}
                                  customOptionValue={0}
                                  customDisplayName="N/A"
                                />
                                <Form.Group as={Col} md={8} style={{ display: esAparatoEditable(aparatoId) ? 'block' : 'none' }}>
                                  <Form.Label> Descripcion *</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name={`aparatoDescripcion_${e.id}`}
                                    placeholder="Escribe su aparato"
                                    value={values[`aparatoDescripcion_${e.id}`]}
                                    onChange={handleChange}
                                    isInvalid={!!errors[`aparatoDescripcion_${e.id}`]}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {errors[`aparatoDescripcion_${e.id}`]}
                                  </Form.Control.Feedback>
                                </Form.Group>
                                
                            </Form.Row>
                            )
                          })
                        }
                      </Form.Group>
                    </Form.Row>
                    <br />

                    <Form.Row>
                      <Form.Group as={Col} md="4">
                        {user &&
                          user.persona &&
                          user.persona.foto &&
                          !profilePicture && (
                            <ProfilePictureComponent
                              size={200}
                              roundedCircle={false}
                            />
                          )}
                        <ImageUpload onFileChange={onFileSelected} />
                      </Form.Group>
                    </Form.Row>

                    <Form.Row>
                      <Form.Group as={Col} md="12">
                        <span className={"fs-20"}>
                          Contacto de emergencia Principal
                        </span>
                      </Form.Group>
                    </Form.Row>

                    <Form.Row>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationFormik21"
                      >
                        <Form.Label>Nombre *</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Pedro José"
                          name="emergencyContactName"
                          value={values.emergencyContactName}
                          onChange={handleChange}
                          //isValid={touched.emergencyContactName && !errors.emergencyContactName}
                          isInvalid={!!errors.emergencyContactName}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.emergencyContactName}
                        </Form.Control.Feedback>
                      </Form.Group>

                      {/* {} */}

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationFormik22"
                      >
                        <Form.Label>Número de teléfono *</Form.Label>
                        <Form.Control
                          as={InputMask}
                          mask="(999) 999-9999"
                          type="text"
                          placeholder="(829) 000-0000"
                          name="emergencyContactPhone"
                          value={values.emergencyContactPhone}
                          onChange={handleChange}
                          //isValid={touched.emergencyContactPhone && !errors.emergencyContactPhone}
                          isInvalid={!!errors.emergencyContactPhone}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.emergencyContactPhone}
                        </Form.Control.Feedback>
                      </Form.Group>

                      <BaseSelect
                        md={3}
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        values={values}
                        label={"Relación * "}
                        name={"emergencyContactKinship"}
                        url={"Parentesco?$filter=Laboral eq 0"}
                      />

                      <Form.Row>
                        <Form.Group as={Col} md="12" style={{ display: emergencyContact.length > 0 ? 'block' : 'none' }}>
                          <span className={"fs-20"}>
                            Contacto de emergencia opcional
                          </span>
                        </Form.Group>
                        {emergencyContact
                          .filter(
                            (x) =>
                              x.estado == 1 && `phoneNumber_${x.id}` in values
                          )
                          .map((element, i) => {
                            return (
                              <FormikEmergencyContact
                                InputMask={InputMask}
                                key={element.id}
                                handleChange={handleChange}
                                errors={errors}
                                touched={touched}
                                values={values}
                                element={element}
                                removeEmergencyContact={
                                  onRemoveEmergencyContact
                                }
                                index={i}
                              />
                            );
                          })}
                      </Form.Row>

                      <Form.Group
                        className={"display-flex space-between"}
                        as={Col}
                        md="12"
                      >
                        {hasPersonalDataReducer ? (
                          <Button
                            size="medium"
                            variant="light"
                            onClick={onExit}
                          >
                            {" "}
                            <b> Cancelar edición </b>{" "}
                          </Button>
                        ) : (
                          <div> </div>
                        )}

                        <div>
                          <Button size="medium" type="button" onClick={onSave}>
                            {" "}
                            <b> Guardar </b>{" "}
                          </Button>
                          <Button
                            className={"margin-left-5"}
                            size="medium"
                            type="button"
                            onClick={onSaveAndContinue}
                          >
                            {" "}
                            <b> Guardar y continuar </b>{" "}
                          </Button>
                        </div>
                      </Form.Group>
                    </Form.Row>
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    changeImage: state.changeImage,
    changeNameOrCareerReducer: state.changeNameOrCareerReducer,
    opeationSuccess: state.opeationSuccess,
    hasPersonalDataReducer: state.hasPersonalDataReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SetUser: (user) => dispatch(SetUser(user)),
    SetLoading: (value) => dispatch(SetLoading(value)),
    UpdateImage: (value) => dispatch(UpdateImage(value)),
    UpdateNameOrCareer: (value) => dispatch(UpdateNameOrCareer(value)),
    SetOperationSuccess: (value) => dispatch(SetOperationSuccess(value)),
    SetHasPersonalData: (value) => dispatch(SetHasPersonalData(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserForm);
